import { Action, createReducer, on } from '@ngrx/store';
import { ErrorResponse, IGenericError } from 'src/app/core/models/generic-models';
import { IAddDirectorRequest } from '../models/add-director.model';
import { fromAddDirectorActions } from '../actions';

export const addDirectorFeatureKey = 'addDirector';

export interface AddDirectorState {
  loadAddDirectorRequest: IAddDirectorRequest;
  loadAddDirectorResponse: string;
  loadAddDirectorFailure: IGenericError<ErrorResponse>;
}

export const initialState: AddDirectorState = {
  loadAddDirectorRequest: undefined,
  loadAddDirectorResponse: undefined,
  loadAddDirectorFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(fromAddDirectorActions.loadAddDirectors, (state, action) => ({
    ...state,
    loadAddDirectorRequest: action.request
  })),
  on(fromAddDirectorActions.loadAddDirectorsSuccess, (state, action) => ({
    ...state,
    loadAddDirectorResponse: action.response
  })),
  on(fromAddDirectorActions.loadAddDirectorsFailure, (state, action) => ({
    ...state,
    loadAddDirectorFailure: action.error
  }))
);

export const getAddDirectorRequest = (state: AddDirectorState) => state.loadAddDirectorRequest;
export const getAddDirectorResponse = (state: AddDirectorState) => state.loadAddDirectorResponse;
export const getAddDirectorFailure = (state: AddDirectorState) => state.loadAddDirectorFailure;
